import { StringUtils } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    // 1-based; the welcome message (step 0) counts as the first step.
    step: number;
}

const STEPS = ['booking', 'contact', 'review', 'done'];

export const StepBar: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const current = Math.max(props.step, 1);

    return (
        <ol className="widget-stepbar" aria-label={t('reservation.steps.label')}>
            {STEPS.map((key, index) => {
                const number = index + 1;
                const state = number < current ? 'done' : number === current ? 'now' : undefined;
                return (
                    <li
                        key={key}
                        className={StringUtils.combineStrings(['widget-stepbar__step', state])}
                        aria-current={state === 'now' ? 'step' : undefined}
                    >
                        <span className="widget-stepbar__bubble">{number}</span>
                        <span className="widget-stepbar__label">{t(`reservation.steps.${key}`)}</span>
                    </li>
                );
            })}
        </ol>
    );
};
